import { render, staticRenderFns } from "./edit-course-work.vue?vue&type=template&id=1fa09524"
import script from "./edit-course-work.vue?vue&type=script&lang=ts&setup=true"
export * from "./edit-course-work.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./edit-course-work.vue?vue&type=style&index=0&id=1fa09524&prod&lang=css"
import style1 from "./edit-course-work.vue?vue&type=style&index=1&id=1fa09524&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports